import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    fetchDashboard,
    fetchDashboardCountData,
    fetchDashboardTodayAttendance,
    fetchDashboardStaffCoverage,
    fetchDashboardBillingAlerts,
    fetchDashboardPeopleLeave,
    fetchDashboardUpcomingEvents,
    fetchDashboardRoomStatus,
    fetchDashboardNeedAttention,
    fetchIndicatorDate,
    fetchParentDashboardAttendance,
    fetchDashboardActionInbox
} from "../../../service/api";

export const getDashboard = createAsyncThunk(
    "dashboard/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDashboard(params);
            console.log("admin dashboard", response);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getDashboardCountData = createAsyncThunk(
    "dashboard/getCountData",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDashboardCountData(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getDashboardTodayAttend = createAsyncThunk(
    "dashboard/getTodayAttend",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDashboardTodayAttendance(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getDashboardStaffStatus = createAsyncThunk(
    "dashboard/getStaffStatus",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDashboardStaffCoverage(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getDashboardInvoiceStatus = createAsyncThunk(
    "dashboard/getInvoiceStatus",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDashboardBillingAlerts(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getDashboardLeaveRequest = createAsyncThunk(
    "dashboard/getLeaveRequest",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDashboardPeopleLeave(params);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getDashboardUpcomingStatus = createAsyncThunk(
    "dashboard/getUpcomingStatus",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDashboardUpcomingEvents(params);
            console.log("upcoming ", response)
            return response.data.data.upcoming_events;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getDashboardChildStatus = createAsyncThunk(
    "dashboard/getChildStatus",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDashboardRoomStatus(params);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getDashboardIncident = createAsyncThunk(
    "dashboard/getIncident",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDashboardNeedAttention(params);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getDashboardChildAttendance = createAsyncThunk(
    "dashboard/getChildAttendance",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchParentDashboardAttendance(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getDashboardActionInbox = createAsyncThunk(
    "dashboard/getActionInbox",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDashboardActionInbox(params);
            console.log("response", response)
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Stub thunks for unused imports kept for backward compat
export const getDashboardCurriculumStatus = createAsyncThunk("dashboard/getCurriculumStatus", async (_, { rejectWithValue }) => { try { return { data: [] }; } catch (e) { return rejectWithValue(e.message); } });
export const getDashboardMealPlan = createAsyncThunk("dashboard/getMealPlan", async (_, { rejectWithValue }) => { try { return { data: [] }; } catch (e) { return rejectWithValue(e.message); } });
export const getDashboardRecentActivity = createAsyncThunk("dashboard/getRecentActivity", async (_, { rejectWithValue }) => { try { return { data: [] }; } catch (e) { return rejectWithValue(e.message); } });
export const getDashboardStaffRole = createAsyncThunk("dashboard/getStaffRole", async (_, { rejectWithValue }) => { try { return { data: [] }; } catch (e) { return rejectWithValue(e.message); } });

export const getDateIndicator = createAsyncThunk(
    "dashboard/getIndicator",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchIndicatorDate(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const dashboardSlice = createSlice({
    name: "dashboards",
    initialState: {
        dashboardData: null,
        indicatorDate: [],
        isLoading: false,
        dashboardLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDashboard.pending, (state) => { state.isLoading = true; state.error = null; })
            .addCase(getDashboard.fulfilled, (state, action) => { state.isLoading = false; state.dashboardData = action.payload.data; })
            .addCase(getDashboard.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })

            .addCase(getDateIndicator.pending, (state) => { state.isLoading = true; state.error = null; })
            .addCase(getDateIndicator.fulfilled, (state, action) => { state.isLoading = false; state.indicatorDate = action.payload.data; })
            .addCase(getDateIndicator.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })

            .addCase(getDashboardCountData.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardCountData.fulfilled, (state, action) => { state.dashboardLoading = false; state.countData = action.payload.data; })
            .addCase(getDashboardCountData.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardActionInbox.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardActionInbox.fulfilled, (state, action) => { state.dashboardLoading = false; state.actionInbox = action.payload.notifications; })
            .addCase(getDashboardActionInbox.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardChildStatus.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardChildStatus.fulfilled, (state, action) => { state.dashboardLoading = false; state.childData = action.payload.rooms; })
            .addCase(getDashboardChildStatus.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardStaffStatus.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardStaffStatus.fulfilled, (state, action) => { state.dashboardLoading = false; state.staffStatus = action.payload.data; })
            .addCase(getDashboardStaffStatus.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardInvoiceStatus.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardInvoiceStatus.fulfilled, (state, action) => { state.dashboardLoading = false; state.invoiceStatus = action.payload.data; })
            .addCase(getDashboardInvoiceStatus.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardCurriculumStatus.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardCurriculumStatus.fulfilled, (state, action) => { state.dashboardLoading = false; state.curriculumStatus = action.payload.data; })
            .addCase(getDashboardCurriculumStatus.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardUpcomingStatus.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardUpcomingStatus.fulfilled, (state, action) => { state.dashboardLoading = false; state.upcomingStatus = action.payload.events; })
            .addCase(getDashboardUpcomingStatus.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardLeaveRequest.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardLeaveRequest.fulfilled, (state, action) => { state.dashboardLoading = false; state.leaveRequest = action.payload.people_and_leave; })
            .addCase(getDashboardLeaveRequest.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardRecentActivity.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardRecentActivity.fulfilled, (state, action) => { state.dashboardLoading = false; state.recentActivity = action.payload.data; })
            .addCase(getDashboardRecentActivity.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardStaffRole.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardStaffRole.fulfilled, (state, action) => { state.dashboardLoading = false; state.staffRole = action.payload.data; })
            .addCase(getDashboardStaffRole.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardMealPlan.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardMealPlan.fulfilled, (state, action) => { state.dashboardLoading = false; state.mealPlanData = action.payload.data; })
            .addCase(getDashboardMealPlan.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardIncident.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardIncident.fulfilled, (state, action) => { state.dashboardLoading = false; state.incidentData = action.payload.needs_attention; })
            .addCase(getDashboardIncident.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardTodayAttend.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardTodayAttend.fulfilled, (state, action) => { state.dashboardLoading = false; state.todayAttend = action.payload.data; })
            .addCase(getDashboardTodayAttend.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getDashboardChildAttendance.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getDashboardChildAttendance.fulfilled, (state, action) => { state.dashboardLoading = false; state.parentAttendance = action.payload.data; })
            .addCase(getDashboardChildAttendance.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })
    }
});

export default dashboardSlice.reducer;
